export enum FlagType {
    ACTUAL,
    SUPERGROUP,
    TARGET,
    GOAL,
}

export enum FlagSide {
    ABOVE,
    BELOW,
}

export enum AdjustedSide {
    LEFT,
    RIGHT,
    NONE,
}

export interface FlagData {
    name: FlagType;
    side: FlagSide;
    position: number;
    adjusted: boolean;
    nearEdge: boolean;
    adjustedSide: AdjustedSide;
}
